<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.WhakaaweWaipaRiverNgaruawahia"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.WaiWaipaRiverNgaruawahia"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.TaiaoKaniwhaniwhaStream"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaiWaitetunaRiver"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WhakaaweLakeOtamanui"></app-basic-cartesian-chart>
